import React from "react";
import { IconButton, Stack, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { customColors } from "models/customColors";
import RefreshIcon from "@mui/icons-material/Refresh";

export const DataGridSearch = ({
  search,
  handleChangeSearch,
  clearSearch,
  title = null,
  loadData,
  withRefreshButton = false,
}) => {
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      gap={2}
      mt={"10px"}
      mb={"10px"}
    >
      {title}
      {withRefreshButton && (
        <IconButton onClick={loadData}>
          <RefreshIcon />
        </IconButton>
      )}
      <TextField
        value={search}
        onChange={handleChangeSearch}
        placeholder="Search"
        InputProps={{
          inputProps: {
            autoComplete: "off",
          },
          startAdornment: (
            <SearchIcon
              sx={{ color: customColors.grayText, margin: "0 10px" }}
            />
          ),
          endAdornment: !search.length ? null : (
            <ClearIcon
              onClick={clearSearch}
              sx={{ cursor: "pointer", margin: "0 10px" }}
            />
          ),
          sx: { height: "40px", borderRadius: "5px" },
        }}
        sx={{
          flex: 1,
          backgroundColor: search === "" ? undefined : customColors.selector,
          height: "40px",
          borderRadius: "5px",
        }}
        variant="standard"
      />
    </Stack>
  );
};
